import { createFileRoute } from '@tanstack/react-router'
import { CatalogPage } from '~/components/catalog/catalog-page'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/products/')({
  component: CatalogPage,
})
